import { Directive, OnInit, inject, input } from '@angular/core';

import { ThemeInverse, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsAccordion } from '@frontend/ui/accordion';

import { AccordionSize, AccordionVariant } from './types';

@Directive({
    selector: '[msThemedAccordion]',
})
export class SportsThemedAccordionDirective implements OnInit {
    themedAccordionSize = input<AccordionSize>();
    themedAccordionVariant = input<AccordionVariant>();
    themedInverse = input<ThemeInverse>();
    currentTheme = injectCurrentTheme();
    accordion = inject(DsAccordion, {
        self: true,
    });

    ngOnInit(): void {
        const variant = this.themedAccordionVariant()?.[this.currentTheme];
        if (variant) {
            this.accordion.variant.set(variant);
        }

        const size = this.themedAccordionSize()?.[this.currentTheme];
        if (size) {
            this.accordion.size.set(size);
        }

        const inverse = this.themedInverse()?.[this.currentTheme];
        if (inverse) {
            this.accordion.inverse.set(inverse.isInverse);
        }
    }
}
